import {
  createSelector,
} from 'reselect';
import * as R from 'ramda';

import {
  getResourceMappedList,
  getSelectionResourceMappedList,
} from './resources';

import {
  sortByOrderName,
  sortByPosition,
} from './utils';

export const getExerciseWithAlternatives = (
  workoutId: number,
  exerciseId: boolean,
) => createSelector(
  getSelectionResourceMappedList('workoutExercises', `workout_${workoutId}`),
  (exercises: any[]) => {
    const exercise = exercises.find((e: any) => e.id === exerciseId);
    exercise.alternatives = exercises.filter((e: any) => e.order_name === exercise.order_name);

    return exercise;
  },
);

const selectedExercises = {};
export const getSortedListWorkoutExercises = (
  workoutId: number,
  withProperty?: boolean,
) => {
  const key = `${workoutId}_${withProperty ? 1 : 0}`;
  if (selectedExercises[key]) return selectedExercises[key];

  selectedExercises[key] = createSelector(
    [
      getSelectionResourceMappedList('workoutExercises', `workout_${workoutId}`),
      getResourceMappedList('exerciseProperties', `workout_${workoutId}`),
    ],
    (
      exercises,
      properties,
    ) => {
      const list = R.pipe(
        R.groupBy(
          item => item.order_name,
        ),

        R.values,
        R.reduce((result, items) => {
          let item = items[0];
          let alternatives = [];

          if (items.length > 1) {
            item = items.find(i => i.is_selected_alternative) || item;
            alternatives = items.filter(i => i.id !== item.id);
          }

          item.alternatives = alternatives;

          if (withProperty) {
            item.properties = properties
              .filter(p => p.workout_exercise_id === item.id)
              .sort(sortByPosition);
          }

          return [
            ...result,
            item,
          ];
        }, []),
        R.sort(sortByOrderName),
      )(exercises);

      return list;
    },
  );

  return selectedExercises[key];
};
